// Three concentric macro rings (protein / carbs / fat) with calories in the centre.
// The hero of the Today screen.

interface RingDatum {
  label: string;
  value: number;
  target: number;
  color: string;
}

interface Props {
  kcal: number;
  kcalTarget: number;
  protein: RingDatum;
  carbs: RingDatum;
  fat: RingDatum;
  size?: number;
}

function Ring({ radius, color, pct }: { radius: number; color: string; pct: number }) {
  const circumference = 2 * Math.PI * radius;
  const clamped = Math.max(0, Math.min(1, pct));
  return (
    <>
      <circle
        cx="100" cy="100" r={radius}
        fill="none" stroke="var(--surface-2)" stroke-width="11"
      />
      <circle
        cx="100" cy="100" r={radius}
        fill="none" stroke={color} stroke-width="11" stroke-linecap="round"
        stroke-dasharray={circumference}
        stroke-dashoffset={circumference * (1 - clamped)}
        transform="rotate(-90 100 100)"
        style={{ transition: "stroke-dashoffset 0.6s cubic-bezier(0.22,1,0.36,1)" }}
      />
    </>
  );
}

export function MacroRings({ kcal, kcalTarget, protein, carbs, fat, size = 220 }: Props) {
  return (
    <div class="rings-hero fade-in">
      <svg width={size} height={size} viewBox="0 0 200 200">
        <Ring radius={86} color={protein.color} pct={protein.value / protein.target} />
        <Ring radius={68} color={carbs.color} pct={carbs.value / carbs.target} />
        <Ring radius={50} color={fat.color} pct={fat.value / fat.target} />
        <text x="100" y="94" text-anchor="middle" fill="var(--text)"
          font-size="34" font-weight="700" letter-spacing="-1">
          {Math.round(kcal)}
        </text>
        <text x="100" y="116" text-anchor="middle" fill="var(--text-faint)"
          font-size="12" letter-spacing="0.5">
          / {kcalTarget} kcal
        </text>
      </svg>

      <div class="rings-legend">
        {[protein, carbs, fat].map((m) => (
          <div class="legend-item" key={m.label}>
            <div class="lv">
              <span class="dot" style={{ background: m.color }} />
              {Math.round(m.value)}<span class="unit">/{m.target}g</span>
            </div>
            <div class="lb">{m.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
